/** @type {<T>(list: T[], direction: (item: T) => number, first?: number, length?: number) => T | undefined} */
export const binarySearch = (
	list,
	direction,
	first = 0,
	length = list.length,
) => {
	if (length === 0) return undefined;
	if (length === 1) {
		if (direction(list[first]) === 0) return list[first];
		return undefined;
	}

	const middle = first + Math.floor(length / 2);
	const dir = direction(list[middle]);
	return (
		// prettier-ignore
		dir === 0 ? list[middle] :
		dir < 0	? binarySearch(list, direction, first, middle - first) :
		binarySearch(list, direction, middle, first + length - middle)
	);
};
